import axios from "axios";
import { BASE_URL } from "../config/configContracts";

// Payload shape for feedback requests
interface FeedbackPayload {
  title: string; // Title of the item being rated
  action: "like" | "dislike"; // User action type
}

export const sendFeedback = async ({ title, action }: FeedbackPayload) => {
  // Validate required fields
  if (!title || !["like", "dislike"].includes(action)) {
    console.error("Invalid payload");
    return;
  }

  try {
    // POST feedback with timestamp
    const response = await axios.post(`${BASE_URL}/feedback`, {
      title,
      action,
      date: new Date().toISOString(),
    });

    console.log("Feedback sent:", response.data);
  } catch (error) {
    console.error("Error sending feedback:", error);
  }
};

/**
 * Fetch aggregated feedback data from the backend API
 * @returns Array of feedback records or empty array on error
 */
export const getAggregatedFeedback = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/feedback`);
    return response.data;
  } catch (error) {
    console.error("Error fetching feedback:", error);
    return [];
  }
};
